import { createRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';
import { rootRoute } from '@/app/rootRoute';
import { ensureSession } from '@/lib/api/auth';
import { isSafeAppPath, str } from '@/lib/search';

export interface LoginSearch {
  next?: string;
}

export const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/login',
  validateSearch: (s: Record<string, unknown>): LoginSearch => ({ next: isSafeAppPath(s.next) ? s.next : undefined }),
  beforeLoad: async ({ search }) => {
    // Already signed in (refresh cookie still valid): go where the user was heading.
    if (await ensureSession()) throw redirect({ href: search.next ?? '/' });
  },
  component: lazyRouteComponent(() => import('./LoginPage')),
});

export const forgotRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/forgot',
  validateSearch: (s: Record<string, unknown>): { email?: string } => ({ email: str(s.email) }),
  component: lazyRouteComponent(() => import('./ForgotPage')),
});

export const resetRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/reset',
  validateSearch: (s: Record<string, unknown>): { email?: string; token?: string } => ({ email: str(s.email), token: str(s.token) }),
  component: lazyRouteComponent(() => import('./ResetPage')),
});

export const authRoutes = [loginRoute, forgotRoute, resetRoute] as const;
